import { Grid } from "@mui/material"
import { formatTime } from "lib/format-time"
import { PeriodSummary, titleFromFrequency } from "./schedule-timing-period-summary"

/**
 * @param {object} props
 * @param {{ list: object[], listTime: number, totalTime: number }} props.item
 */
export function ScheduleTimingPeriodGridItem({ item: { list, listTime, totalTime } }) {
    const [{ frequency }] = list
    const timingClass = titleFromFrequency(frequency)

    return (
        <Grid item className={`schedule-timing ${timingClass}`}>
            <PeriodSummary
                frequency={frequency}
                number={formatTime(list.reduce((a, task) => a + (task.minutes ?? 0), 0))}
                total={list.length}
                time={formatTime(listTime)}
                percent={(listTime / totalTime) * 100}
            />
        </Grid>
    )
}
